import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, EyeIcon } from 'lucide-react';
type Page = {
  imageUrl: string;
  volume: string;
  title: string;
  description: string;
};
const pages: Page[] = [{
  imageUrl: 'https://cdn.magicpatterns.com/uploads/2AsiLeEA26gHwJnyFa6Ukf/Captura-de-pantalla-2026-07-28-a-las-8.32.16_p._m..webp',
  volume: 'Volumi 01–02',
  title: 'La Biomeccanica per i Piccoli',
  description: 'I 3 punti chiave del dritto per i 7-8 anni: presa, backswing e impatto spiegati punto per punto.'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/e97pJHXbTxY55byBPVDdkM/Captura-de-pantalla-2026-07-28-a-las-8.34.59_p._m..webp',
  volume: 'Volumi 01–02',
  title: 'Dal Trofeo al Servizio Completo',
  description: 'Una progressione in 4 fasi per costruire il servizio, dalla statua del trofeo alla frusta finale.'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/vzr7VaAa9i2i82Ru8cy418/Captura-de-pantalla-2026-07-28-a-las-8.36.35_p._m..webp',
  volume: 'Sessioni pronte',
  title: 'Sessione Pronta N°2',
  description: '60 minuti già strutturati: riscaldamento, tecnica e drills giocati, minuto per minuto.'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/9epqvYdmQ4L88Dz5oJ11Kk/Captura-de-pantalla-2026-07-28-a-las-8.40.06_p._m..webp',
  volume: 'Volume 04',
  title: 'Il Diario dell’Agonista',
  description: 'La scheda da stampare per analizzare ogni match: gioco, testa e prossimo obiettivo.'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/3GTcBRwoFaRvrSLuRaNDq3/Captura_de_pantalla_2026-07-28_a_las_8.41.50_p.webp',
  volume: 'Volume 05',
  title: 'La Velocità nei Bambini — Under 12',
  description: 'Esercizi di coordinazione e reattività pronti da portare in campo con i gruppi Under 12.'
}];
export function PreviewSection() {
  const [index, setIndex] = useState(0);
  const total = pages.length;
  const goTo = (next: number) => setIndex((next + total) % total);
  return <section className="bg-[#0a0f0c] px-5 py-20" data-id="element-144" data-mp="35eus3eyzn3mp">
      <div className="mx-auto max-w-5xl" data-id="element-145" data-mp="3aeqoas1g1qrp">
        <div className="mx-auto max-w-2xl text-center" data-id="element-146" data-mp="3adfikmofu8xy">
          <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-emerald-300" data-id="element-147" data-mp="3f7jtti4ql34u">
            <EyeIcon className="h-4 w-4" data-id="element-148" data-mp="3k51z8yjjp083" />
            Guarda dentro il materiale
          </p>
          <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-149" data-mp="2mje6qoq7n21u">
            Ecco come sono fatte{' '}
            <span className="text-emerald-300" data-id="element-150" data-mp="2wg90yvfgagab">le pagine</span>
          </h2>
          <p className="mt-4 text-sm font-medium leading-relaxed text-slate-300" data-id="element-151" data-mp="2widhccujd7rh">
            Schede chiare, visive e pronte da usare in campo — nessun testo
            infinito, solo ciò che ti serve durante la lezione.
          </p>
        </div>

        <div className="relative mt-12" data-id="element-152" data-mp="fqc1bdynbyvy">
          <div className="grid items-center gap-8 lg:grid-cols-[minmax(0,420px)_1fr] lg:gap-12" data-id="element-153" data-mp="ftgc4u6m9svl">
            <div className="relative mx-auto w-full max-w-[420px]" data-id="element-154" data-mp="20bifon4ltzie">
              <div className="overflow-hidden border border-emerald-300/25 bg-[#141b16] p-3" data-id="element-155" data-mp="1w93wu30xqzr4">
                <img key={pages[index].imageUrl} src={pages[index].imageUrl} alt={`Anteprima della pagina: ${pages[index].title}`} loading="lazy" className="w-full object-contain" data-id="element-156" data-mp="1rft1oz5hk7f1" />
              </div>

              <button type="button" onClick={() => goTo(index - 1)} aria-label="Pagina precedente" className="absolute left-0 top-1/2 grid h-12 w-12 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full border-2 border-emerald-400 bg-[#102016] text-emerald-300 shadow-xl transition hover:bg-emerald-400 hover:text-[#102016]" data-id="element-157" data-mp="1cia2f2v6mbtc">
                <ChevronLeftIcon className="h-6 w-6" data-id="element-158" data-mp="2xxy1u27z7lca" />
              </button>
              <button type="button" onClick={() => goTo(index + 1)} aria-label="Pagina successiva" className="absolute right-0 top-1/2 grid h-12 w-12 -translate-y-1/2 translate-x-1/2 place-items-center rounded-full border-2 border-emerald-400 bg-[#102016] text-emerald-300 shadow-xl transition hover:bg-emerald-400 hover:text-[#102016]" data-id="element-159" data-mp="1unk4l8ooznpa">
                <ChevronRightIcon className="h-6 w-6" data-id="element-160" data-mp="1bug9rjzqn4t3" />
              </button>
            </div>

            <div className="text-center lg:text-left" aria-live="polite" data-id="element-161" data-mp="1gnsjyp3o792b">
              <p className="text-xs font-bold uppercase tracking-widest text-emerald-300" data-id="element-162" data-mp="12w4cx08a3as7">
                {pages[index].volume}
              </p>
              <h3 className="mt-3 font-display text-3xl font-bold uppercase leading-none text-white sm:text-4xl" data-id="element-163" data-mp="16ubolgnvxlwj">
                {pages[index].title}
              </h3>
              <p className="mt-4 text-sm font-medium leading-relaxed text-slate-300" data-id="element-164" data-mp="xvgh8193u5rn">
                {pages[index].description}
              </p>
              <p className="mt-6 text-xs font-bold uppercase tracking-widest text-slate-400" data-id="element-165" data-mp="9bd74gfm1y0v">
                Pagina {index + 1} di {total}
              </p>
              <div className="mt-4 flex justify-center gap-2 lg:justify-start" data-id="element-166" data-mp="o9p5crimteu5">
                {pages.map((page, dotIndex) => <button key={page.imageUrl} type="button" onClick={() => goTo(dotIndex)} aria-label={`Vai alla pagina ${dotIndex + 1}`} aria-current={dotIndex === index} className={`h-2.5 rounded-full transition-all ${dotIndex === index ? 'w-8 bg-emerald-400' : 'w-2.5 bg-white/25 hover:bg-white/50'}`} data-id="element-167" data-mp="x92bpbbglnan" data-mpi={dotIndex} />)}
              </div>
            </div>
          </div>
        </div>

        <p className="mt-12 text-center text-sm font-semibold text-white" data-id="element-168" data-mp="1j1ojbbmi40wl">
          Oltre 460 pagine come queste, già pronte per le tue lezioni.
        </p>
      </div>
    </section>;
}